/**
 * Parsea un color en formato #rgb, #rrggbb, rgb(...) o rgba(...) a [r, g, b].
 * Devuelve null si no se puede interpretar.
 */
export const parseColorToRgb = (color) => {
  if (!color || typeof color !== 'string') return null;
  const c = color.trim();

  const rgbMatch = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgbMatch) {
    return [Number(rgbMatch[1]), Number(rgbMatch[2]), Number(rgbMatch[3])];
  }

  const hex = c.replace('#', '');
  const full = hex.length === 3 ? hex.split('').map(ch => ch + ch).join('') : hex;
  if (full.length !== 6 || /[^0-9a-f]/i.test(full)) return null;
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
};

/**
 * Convierte cualquier color soportado (hex o rgb/rgba) a rgba(...) con la
 * transparencia indicada. Si no se puede parsear, usa el fallback indigo.
 */
export const hexAlpha = (color, alpha) => {
  const rgb = parseColorToRgb(color) || parseColorToRgb('#4f46e5');
  const [r, g, b] = rgb;
  return `rgba(${r},${g},${b},${alpha})`;
};
